import { render, staticRenderFns } from "./PurchaseInvoicesBillingCard.vue?vue&type=template&id=621a4080&scoped=true&"
import script from "./PurchaseInvoicesBillingCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseInvoicesBillingCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621a4080",
  null
  
)

export default component.exports